import { render, staticRenderFns } from "./BTN017n_left.vue?vue&type=template&id=492d8a51&scoped=true&"
import script from "./BTN017n_left.vue?vue&type=script&lang=js&"
export * from "./BTN017n_left.vue?vue&type=script&lang=js&"
import style0 from "./BTN017n_left.vue?vue&type=style&index=0&id=492d8a51&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d8a51",
  null
  
)

export default component.exports